// eslint-disable-next-line
import util from 'util';

import * as actionTypes from '../actionTypes';

import * as PortalApi from '../PortalApi';
import * as accountSelectors from '../account/selectors';
import * as coreActions from '../core/actions';
import * as AccountApi from '../account/api';
import { formatPhoneNumber } from '../ui/Formatters';
import * as coreSelectors from "../core/selectors";
import * as Formatters from "../ui/Formatters";

/* */
export const setAccountId = (accountId) => ({
  type : actionTypes.SET_ACCOUNT_ID,
  payload : { accountId }
});

/* */
export const setAccount = (account) => ({
  type : actionTypes.SET_ACCOUNT,
  payload : { account }
});

/* Called when we get a push update notification */
export const pushUpdate = () => {
  return function(dispatch, getState) {
    /* Query the account again if one is selected */
    if (typeof(accountSelectors.getAccountId(getState())) === 'number') {
      dispatch(queryAccount());
    }
  }
}

/* Query the account information for accountId */
var queryingAccount = false;
export const queryAccount = () => {
  return function(dispatch, getState) {
    if (queryingAccount) {
      return;
    }
    // dispatch(getPlaidLinkToken({}));
    queryingAccount = true;
    dispatch(setAccountLoading(true));
    AccountApi.queryAccount((account) => {
      dispatch(setAccountLoading(false));
      dispatch(setAccount(account));
      // dispatch(getPlaidLinkToken(account.accountId));
      dispatch(queryPaymentMethods(accountSelectors.getAccountId(getState())));
      queryingAccount = false;
    }, (error, status, content) => {
      dispatch(setAccountLoading(false));
      queryingAccount = false;
      PortalApi.defaultErrorHandler(error, status, content);
    }, accountSelectors.getAccountId(getState()));
  }
}

/* Query the account information for accountId */
export const queryAccountInfo = () => {
  return function(dispatch, getState) {
    dispatch(getPlaidLinkToken({}));
    dispatch(setAccountLoading(true));
    AccountApi.queryAccount((account) => {
      dispatch(setAccountLoading(false));
      dispatch(setAccount(account));
    }, (error, status, content) => {
      dispatch(setAccountLoading(false));
      PortalApi.defaultErrorHandler(error, status, content);
    }, accountSelectors.getAccountId(getState()));
  }
}

export const changeAccount = (accountId, change, changeSummary) => {
  return function(dispatch, getState) {
    AccountApi.queryAccount((account) => {
      change(account);
      AccountApi.updateAccount(() => {
        dispatch(coreActions.updateUser());
      }, null, account, changeSummary);
    }, null, accountId);
  }
}

export const saveEditAccount = (updatedDetails) => {
  return function(dispatch, getState) {
    if(updatedDetails.editType === 'billing'){
      dispatch(changeAccount(updatedDetails.accountId,
        (account) => {
          account.billingAddress1 = updatedDetails.billingAddress1;
          account.billingAddress2 = updatedDetails.billingAddress2;
          account.billingCity = updatedDetails.billingCity;
          account.billingUsState = updatedDetails.billingUsState;
          account.billingTerritory = updatedDetails.billingTerritory;
          account.billingCountry = updatedDetails.billingCountry;
          account.billingUsZip = updatedDetails.billingUsZip;
          account.billingPostalCode = updatedDetails.billingPostalCode;
          account.billingEmail = updatedDetails.billingEmail;
          account.shippingSameAsBilling = updatedDetails.shippingSameAsBilling;
        }, 'Update General Information'));
    } else {
      dispatch(changeAccount(updatedDetails.accountId,
        (account) => {
          account.shippingSameAsBilling = updatedDetails.shippingSameAsBilling;
          account.shippingAddress1 = updatedDetails.shippingAddress1;
          account.shippingAddress2 = updatedDetails.shippingAddress2;
          account.shippingCity = updatedDetails.shippingCity;
          account.shippingUsState = updatedDetails.shippingUsState;
          account.shippingTerritory = updatedDetails.shippingTerritory;
          account.shippingCountry = updatedDetails.shippingCountry;
          account.shippingUsZip = updatedDetails.shippingUsZip;
          account.shippingPostalCode = updatedDetails.shippingPostalCode;
        }, 'Update General Information'));
    }
  }
}



/* */
export const setAccountLoading = (accountLoading) => ({
  type : actionTypes.SET_ACCOUNT_LOADING,
  payload : { accountLoading }
});

/* */
export const setCalleridRequest = (calleridRequest) => ({
  type : actionTypes.SET_CALLERID_REQUEST,
  payload : { calleridRequest }
});

/* Submit a caller-id request */
export const requestCallerId = (accountId, phoneNumber) => {
  return function(dispatch, getState) {
    dispatch(setCalleridRequest({ status : 'requesting'}));
    AccountApi.requestCallerId((callerIdRequest) => {
      if (callerIdRequest.failedReason) {
        dispatch(coreActions.postSnackMessage('error', callerIdRequest.failedReason));
        dispatch(setCalleridRequest({}));
      } else {
        dispatch(setCalleridRequest(callerIdRequest));
      }
    }, (error, status, content) => {
      dispatch(setCalleridRequest({}));
      PortalApi.defaultErrorHandler(error, status, content);
    }, accountId, phoneNumber);
  }
}

/* Remove a Caller-Id request */
export const removeCallerId = (accountCalleridId) => {
  return function(dispatch, getState) {
    AccountApi.removeCallerId(undefined, undefined, accountCalleridId);
  }
}

/* */
export const setInvoice = (invoice) => ({
  type : actionTypes.SET_INVOICE,
  payload : { invoice }
});

/* */
export const setInvoiceOpen = (invoiceOpen) => ({
  type : actionTypes.SET_INVOICE_OPEN,
  payload : { invoiceOpen }
});

/* Query an invoice */
export const queryInvoice = (accountId, invoiceId) => {
  return function(dispatch, getState) {
    dispatch(setInvoice({}));
    AccountApi.queryInvoice((invoice) => {
      dispatch(setInvoice(invoice));
    }, undefined, accountId, invoiceId);
  }
}

export const querySurcharge = (accountId, invoiceId, paymentMethodUid, amount) => {
  return function(dispatch, getState) {
    dispatch(setQueryingSurcharge(true));
    AccountApi.queryPaymentSurcharge((surchargeResponse) => {
      dispatch(setQueryingSurcharge(false));
      dispatch(setSurchargeQueried(true));
      let obj = {};

      obj.amount = surchargeResponse.amount;
      obj.surchargeExemptStatus = surchargeResponse.status;
      obj.surchargeText = surchargeResponse.surchargeText;
      obj.totalAmount = surchargeResponse.totalAmount;
      obj.surchargePercent = surchargeResponse.surchargePercent
      if (surchargeResponse.surchargeAmount) {
        obj.surchargeAmount = Number(surchargeResponse.surchargeAmount);
        if (typeof (obj.surchargeAmount) === 'number') {
          obj.surchargeAmount = Number(obj.surchargeAmount.toFixed(2));
        }
      } else {
        obj.surchargeAmount = null;
      }

      //From the above function.
      obj.funding = surchargeResponse?.funding;
      obj.methodType = surchargeResponse?.methodType;
      obj.fetched = true;
      obj.receivedConsent = false;
      obj.displayed = false;
      obj.displayedNotice = false;
      obj.consentUserId = null;

      if ((surchargeResponse?.surchargeAmount ?? 0) > 0) {
        //Display a surcharge notice
        dispatch(setSurchargeObject(obj));
        dispatch(setShowPaymentConfirmation(true));
      } else {
        //Don't display a notice, just submit the payment for the amount requested.
        //However, we still include the object returned from the API for recording purposes.
        dispatch(setSurchargeObject(obj));
        dispatch(setShowPaymentConfirmation(false));
        dispatch(setOkToSubmitPayment(true));
        dispatch(payInvoice(accountId, invoiceId, paymentMethodUid, amount, obj));
      }


    }, (error, status, content) => {
      dispatch(setQueryingSurcharge(false));
      dispatch(setShowPaymentConfirmation(false));
      dispatch(setOkToSubmitPayment(false));
      dispatch(coreActions.postSnackMessage('error', 'Unable to fetch surcharge data, payments cannot be processed at this time.'));
      PortalApi.defaultErrorHandler(error, status, content);
    }, accountId, invoiceId, paymentMethodUid, amount);

  }
}

/* Pay an invoice */
export const payInvoice = (accountId, invoiceId, paymentMethodUid, amount, surchargeMetadata) => {
  return function(dispatch, getState) {
    dispatch(setSubmittingPayment(true));
    const agentUserSession = coreSelectors.getAgentUserSession(getState());
    AccountApi.payInvoice(() => {
      dispatch(setSubmittingPayment(false));
      dispatch(setStoredPaymentOpen(false));
      dispatch(setShowPaymentConfirmation(false));
      dispatch(setQueryingSurcharge(false));
      dispatch(setSurchargeQueried(false));
      dispatch(setSurchargeObject({}));
      dispatch(coreActions.postSnackMessage('success', 'Payment successfully submitted.  Thank you.'));
    }, (error, status, content) => {
      dispatch(setSubmittingPayment(false));
      dispatch(setShowPaymentConfirmation(false));
      dispatch(setQueryingSurcharge(false));
      dispatch(setSurchargeQueried(false));
      dispatch(setSurchargeObject({}));
      PortalApi.defaultErrorHandler(error, status, content);
    }, accountId, invoiceId, paymentMethodUid, amount, surchargeMetadata, agentUserSession);
  }
}

/* Query available payment methods */
var queryingPaymentMethods = false;
export const queryPaymentMethods = (accountId) => {
  if (queryingPaymentMethods) {
    return;
  }
  queryingPaymentMethods = true;
  return function(dispatch, getState) {
    queryingPaymentMethods = false;
    AccountApi.queryPaymentMethods((paymentMethods) => {
      queryingPaymentMethods = false;
      const autopayMethodUid = paymentMethods?.autopayPaymentMethodUid;
      //Check which one is active on the account, and adjust the property
      const rec = (paymentMethods?.paymentMethods || []).map(item => {
        item.isSetAsAutopayActive = (item.id === autopayMethodUid);
        //Map out the display value:
        let formattedMethod = Formatters.formatPaymentMethod(item, true);
        item.displayValue = formattedMethod.brand + ' ' + formattedMethod.number;
        if ((formattedMethod.exp ?? null) !== null) {
          item.displayValue = item.displayValue + ' exp ' + formattedMethod.exp;
        }
        if (item.isSetAsAutopayActive) {
          item.displayValue = item.displayValue + ' (Default)';
        }
        return item;
      });
      dispatch(setPaymentMethods({paymentMethods: rec}));
    }, (error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
      dispatch(setPaymentMethods({}));
    }, accountId);
  }
}

/* Finish create a new payment method attached to the customer */
export const createPaymentMethod = (accountId, paymentMethodUid) => {
  return function(dispatch, getState) {
    dispatch(setAddingPaymentMethod(true));
    /* New method automatically becomes the autopay method */
    AccountApi.enableAutopay(() => {
      dispatch(coreActions.postSnackMessage('success', 'Payment method saved.'));
      dispatch(setAddPaymentMethodOpen(false));
      dispatch(setAddingPaymentMethod(false));
      dispatch(queryAccount());
    }, (error, status, content) => {
      PortalApi.defaultErrorHandler(error.split(';')[0], status, content);
      dispatch(setAddingPaymentMethod(false));
    }, accountId, paymentMethodUid);
  }
}

/* Remove a payment method from an account */
export const deletePaymentMethod = (accountId, paymentMethodUid) => {
  return function(dispatch, getState) {
    AccountApi.deletePaymentMethod(() => {
      dispatch(coreActions.postSnackMessage('success', 'Payment method deleted.'));
      dispatch(queryPaymentMethods(accountId));
    }, (error, status, content) => {
      PortalApi.defaultErrorHandler(error.split(';')[0], status, content);
    }, accountId, paymentMethodUid);
  }
}

/* Save a payment method edit.  Currently only the expiration date for cards */
export const savePaymentMethod = (accountId, paymentMethodUid, month, year) => {
  return function(dispatch, getState) {
    dispatch(setSavingPaymentMethod(true));      
    AccountApi.savePaymentMethod(() => {
      dispatch(coreActions.postSnackMessage('success', 'Payment method updated.'));
      dispatch(queryPaymentMethods(accountId));
      dispatch(setUpdatePaymentMethodOpen(false));
      dispatch(setSavingPaymentMethod(false));      
    }, (error, status, content) => {
      dispatch(setSavingPaymentMethod(false));
      PortalApi.defaultErrorHandler(error.split(';')[0], status, content);
    }, accountId, paymentMethodUid, month, year);
  }
}


/* */
export const setPaymentMethods = (paymentMethods) => ({
  type : actionTypes.SET_PAYMENT_METHODS,
  payload : { paymentMethods }
});

/* */
export const setStoredPaymentOpen = (storedPaymentOpen) => ({
  type : actionTypes.SET_STORED_PAYMENT_OPEN,
  payload : { storedPaymentOpen }
});

/* */
export const setSubmittingPayment = (submittingPayment) => ({
  type : actionTypes.SET_SUBMITTING_PAYMENT,
  payload : { submittingPayment }
});


export const setQueryingSurcharge = (queryingSurcharge) => ({
  type : actionTypes.SET_SUBMITTING_PAYMENT,
  payload : { queryingSurcharge }
});

export const setSurchargeQueried = (surchargeQueried) => ({
  type : actionTypes.SET_SUBMITTING_PAYMENT,
  payload : { surchargeQueried }
});

export const setShowPaymentConfirmation = (showPaymentConfirmation) => ({
  type : actionTypes.SET_SHOW_PAYMENT_CONFIRMATION,
  payload : { showPaymentConfirmation }
});

export const setOkToSubmitPayment = (okToSubmitPayment) => ({
  type : actionTypes.SET_OK_TO_SUBMIT_PAYMENT,
  payload : { okToSubmitPayment }
});

export const setSurchargeObject = (surchargeObject) => ({
  type : actionTypes.SET_SURCHARGE_OBJECT,
  payload : { surchargeObject }
});

/* */
export const setAutopayEnrollOpen = (autopayEnrollOpen) => ({
  type : actionTypes.SET_AUTOPAY_ENROLL_OPEN,
  payload : { autopayEnrollOpen }
});

/* */
export const setSubmittingAutopayEnroll = (submittingAutopayEnroll) => ({
  type : actionTypes.SET_SUBMITTING_AUTOPAY_ENROLL,
  payload : { submittingAutopayEnroll }
});


/* Enable autopayment */
export const enableAutopay = (accountId, paymentMethodUid) => {
  return function(dispatch, getState) {
    dispatch(setSubmittingAutopayEnroll(true));
    AccountApi.enableAutopay(() => {
      dispatch(setAutopayEnrollOpen(false));
      dispatch(setSubmittingAutopayEnroll(false));
      dispatch(coreActions.postSnackMessage('success', 'Payment method activated.'));
      dispatch(queryAccount());      
    }, (error, status, content) => {
      dispatch(setSubmittingAutopayEnroll(false));
      PortalApi.defaultErrorHandler(error, status, content);
    }, accountId, paymentMethodUid);
  }
}

/* Disable autopayment */
export const disableAutopay = (accountId) => {
  return function(dispatch, getState) {
    AccountApi.disableAutopay(() => {
      dispatch(coreActions.postSnackMessage('success', 'Automatic payment successfully disabled.'));
      dispatch(queryAccount());      
    }, (error, status, content) => {
      dispatch(setSubmittingAutopayEnroll(false));
      PortalApi.defaultErrorHandler(error, status, content);
    }, accountId);
  }
}


/* */
export const setCallSummaryStats = (callSummaryStats) => ({
  type : actionTypes.SET_CALL_SUMMARY_STATS,
  payload : { callSummaryStats }
});

/* Query an call summmary stats */
export const callSummaryStats = (accountId,invoiceId) => {
  return function(dispatch, getState) {
    dispatch(setCallSummaryStats({}));
    AccountApi.getCallSummaryStats((stats) => {
      dispatch(setCallSummaryStats(stats));
    },(error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
    }, accountId,invoiceId);
  }
}

/* Query combined call summmary stats */
export const combinedCallSummaryStats = (accountId,invoiceId) => {
  return function(dispatch, getState) {
    dispatch(setCallSummaryStats({}));
    AccountApi.getCombinedCallSummaryStats((stats) => {
      dispatch(setCallSummaryStats(stats));
    },(error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
    }, accountId,invoiceId);
  }
}

export const setCallVolumes = (callVolumesBarGraphData) => ({
  type : actionTypes.SET_CALL_VOLUMES_BAR_GRAPH,
  payload : { callVolumesBarGraphData }
});

export const callVolumes = (accountId,invoiceId, type) => {
  return function(dispatch, getState) {
    dispatch(setCallVolumes({}));
    AccountApi.getCallVolumeBarData((stats) => {
      stats.id = new Date().getTime();
      dispatch(setCallVolumes(stats));
    },(error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
      dispatch(setCallVolumes({}));
    }, accountId,invoiceId, type);
  }
}

export const setContactInsights = (contactInsightsBarData) => ({
  type : actionTypes.SET_CONTACT_INSIGHTS_BAR_GRAPH,
  payload : { contactInsightsBarData }
});

export const contactInsights = (accountId,invoiceId) => {
  return function(dispatch, getState) {
    AccountApi.getContactInsightsWeeklyData((stats) => {
      stats.id = new Date().getTime();
      dispatch(setContactInsights(stats));
    },(error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
    }, accountId,invoiceId);
  }
}

export const setGetTasksByInvoice = (tasksByInvoice) => ({
  type : actionTypes.SET_TASK_BY_INVOICE,
  payload : { tasksByInvoice }
});

/* Query an call summmary stats */
export const getTasksByInvoice = (accountId,invoiceId) => {
  return function(dispatch, getState) {
    dispatch(setGetTasksByInvoice([]));
    AccountApi.getTasksByInvoice((stats) => {
      dispatch(setGetTasksByInvoice(stats));
    },(error, status, content) => {
      dispatch(setGetTasksByInvoice([]));
      PortalApi.defaultErrorHandler(error, status, content);
    }, accountId,invoiceId);
  }
}

/* */
export const setInvoiceId = (invoiceId) => ({
  type : actionTypes.SET_INVOICE_ID,
  payload : { invoiceId }
});


export const setWebLeads = (chats) => ({
  type : actionTypes.SET_WEB_LEADS,
  payload : { chats }
});

export const queryChats = (accountId) => {
  return function(dispatch, getState) {
    dispatch(setWebLeads([]));
    AccountApi.queryChatsByAccount((stats) => {
      var processedChats = []
      stats.forEach(element => {
          var newElement = {...element}
          newElement.webleadJson = JSON.parse(newElement.webLead)
          processedChats.push(newElement)
      });
      dispatch(setWebLeads(processedChats));
    },(error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
      dispatch(setWebLeads([]));
    }, accountId);
  }
}
/* */
export const setPaymentMethod = (paymentMethod) => ({
  type : actionTypes.SET_PAYMENT_METHOD,
  payload : { paymentMethod }
});

/* */
export const setAddPaymentMethodOpen = (addPaymentMethodOpen) => ({
  type : actionTypes.SET_ADD_PAYMENT_METHOD_OPEN,
  payload : { addPaymentMethodOpen }
});

/* */
export const setAddingPaymentMethod = (addingPaymentMethod) => ({
  type : actionTypes.SET_ADDING_PAYMENT_METHOD,
  payload : { addingPaymentMethod }
});

/* */
export const setUpdatePaymentMethodOpen = (updatePaymentMethodOpen) => ({
  type : actionTypes.SET_UPDATE_PAYMENT_METHOD_OPEN,
  payload : { updatePaymentMethodOpen }
});

/* */
export const setUpdatePaymentMethod = (updatePaymentMethod) => ({
  type : actionTypes.SET_UPDATE_PAYMENT_METHOD,
  payload : { updatePaymentMethod }
});

/* */
export const setSavingPaymentMethod = (savingPaymentMethod) => ({
  type : actionTypes.SET_SAVING_PAYMENT_METHOD,
  payload : { savingPaymentMethod }
});

/* */
export const setPlaidLinkToken = (plaidLinkToken) => ({
  type : actionTypes.SET_PLAID_LINK_TOKEN,
  payload : { plaidLinkToken }
});

/* Get a token used to generate the PLAID link */
export const getPlaidLinkToken = (accountId) => {
  return function(dispatch, getState) {
    AccountApi.getPlaidLinkToken((token) => {
      dispatch(setPlaidLinkToken(token));
    },(error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
    }, accountId);
  }
}

/* Attach the account linked by plaid to the Stripe Customer */
export const attachPlaidToken = (accountId, publicToken, bankAccountId, activate) => {
  return function(dispatch, getState) {
    dispatch(setAddingBankAccount(true));
    AccountApi.attachPlaidToken(() => {
      dispatch(setAddingBankAccount(false));
      dispatch(setAddBankAccountOpen(false));
      dispatch(queryAccount());
      dispatch(coreActions.postSnackMessage('success', 'Bank account successfully added.'));
    },(error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
      dispatch(setAddingBankAccount(false));
    }, accountId, publicToken, bankAccountId, activate ? 'Y' : 'N');
  }
}

/* */
export const setPlaidAuthResponse = (plaidAuthResponse) => ({
  type : actionTypes.SET_PLAID_AUTH_RESPONSE,
  payload : { plaidAuthResponse }
});

/* A bank account authorized was completed from plaid */
export const plaidAuthorization = (metadata) => {
  return function(dispatch, getState) {
    dispatch(setPlaidAuthResponse(metadata));
    dispatch(setAddingBankAccount(false));
    dispatch(setAddBankAccountOpen(true));

    /*
    dispatch(attachPlaidToken(accountSelectors.getAccount(getState()).accountId,
                              metadata.public_token,
                              metadata.accounts[0].id));
    */
  }
}


/* */
export const setAddBankAccountOpen = (addBankAccountOpen) => ({
  type : actionTypes.SET_ADD_BANK_ACCOUNT_OPEN,
  payload : { addBankAccountOpen }
});

/* */
export const setAddingBankAccount = (addingBankAccount) => ({
  type : actionTypes.SET_ADDING_BANK_ACCOUNT,
  payload : { addingBankAccount }
});

export const setPhoneNumberInsights = (phoneNumberInsights) =>{
  return ({
    type : actionTypes.SET_PHONE_NUMBER_INSIGHTS,
    payload : { phoneNumberInsights }
  })
}

/* A bank account authorized was completed from plaid */
export const fetchSetupIntent = (accountId, success, failed) => {
  return function(dispatch, getState) {
    AccountApi.getSetupIntent((intent) => {
      if (typeof(success) === 'function') {
        success(intent);
      }
    }, (error, status, content) => {
      if (typeof(failed) === 'function') {
        failed();
      }
      PortalApi.defaultErrorHandler(error, status, content);
    }, accountId);
  }
}

/* Redirect to the add payment page */
export const redirectToAddPayment = (accountId) => {
  return function(dispatch, getState) {
    AccountApi.getCheckoutSession((session) => {
      window.location.href = session.url;
    }, (error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
    }, accountId);
  }
}

/* Redirect to the checkout page */
export const openCheckoutSession = (accountId) => {
  return function(dispatch, getState) {
    AccountApi.getCheckoutSession((session) => {
      window.location.href = session.url;
    }, (error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
    }, accountId);
  }
}

/* Download PDF Invoice */
export const downloadPdfInvoice = (accountId, invocieId) => {
  return function(dispatch, getState) {
    AccountApi.downloadPdfInvoice((result) => {
      window.location.href = result.pdfInvoiceUrl;
    }, (error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
    }, accountId, invocieId);
  }
}

export const getPhoneNumberInsights = (accountId) => {
  return function(dispatch, getState) {
    AccountApi.getPhoneNumberInsights((result) => {
      let series = [];
      if(Array.isArray(result)){
        let account = accountSelectors.getAccount(getState());
        let phoneNumbers = [...new Set(account?.phoneNumbers?.map((item) => item.phoneNumber))];
        let categories = [...new Set(result.map((item) => item.call_date))];
        let counts = phoneNumbers.map(phoneNumber => {
          let count = result.filter((item) => item.dnis === phoneNumber).map((item) => item.call_count).reduce((a, b) => a + b, 0);
          return { phoneNumber, count };
        });
        counts.sort((a, b) => b.count - a.count);

        let top6 = counts.slice(0, 6);

        phoneNumbers = []
        top6.forEach(item => {
          phoneNumbers.push(item.phoneNumber);
          let phoneNumber = item.phoneNumber;
          let data = categories.map((category) => result.find((item) => item.dnis === phoneNumber && item.call_date === category) ? result.find((item) => item.dnis === phoneNumber && item.call_date === category).call_count : 0);
          series.push({data: data, name: formatPhoneNumber(phoneNumber)});
        });
        // phoneNumbers.forEach(phoneNumber => {
        //   let data = categories.map((category) => result.find((item) => item.dnis === phoneNumber && item.call_date === category) ? result.find((item) => item.dnis === phoneNumber && item.call_date === category).call_count : 0);
        //   series.push({data: data, name: formatPhoneNumber(phoneNumber)});
        // })
        dispatch(setPhoneNumberInsights(result));
      }
    }, (error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
    }, accountId);
  }
}

export const queryBillingEmails = () => {
  return function(dispatch, getState) {
    const accountId = accountSelectors.getAccountId(getState());
    if (!accountId) return; // Don't query if no account selected
    
    AccountApi.queryBillingEmails((mailingList) => {
      dispatch({type: actionTypes.SET_BILLING_EMAILS, payload: { billingEmails: mailingList }});
    }, (error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
      // Set empty list on error to prevent undefined state
      dispatch({type: actionTypes.SET_BILLING_EMAILS, payload: { billingEmails: { destinations: [] } }});
    }, accountId);
  }
}

export const addBillingEmailAction = (address) => {
  return function(dispatch, getState) {
    const accountId = accountSelectors.getAccountId(getState());
    if (!accountId) return;
    
    AccountApi.addBillingEmail((mailingList) => {
      dispatch({type: actionTypes.SET_BILLING_EMAILS, payload: { billingEmails: mailingList }});
      dispatch(coreActions.postSnackMessage('success', 'Email added successfully'));
    }, (error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
    }, accountId, address);
  }
}

export const deleteBillingEmailAction = (destinationId) => {
  return function(dispatch, getState) {
    const accountId = accountSelectors.getAccountId(getState());
    if (!accountId) return;
    
    AccountApi.deleteBillingEmail((mailingList) => {
      dispatch({type: actionTypes.SET_BILLING_EMAILS, payload: { billingEmails: mailingList }});
      dispatch(coreActions.postSnackMessage('success', 'Email deleted successfully'));
    }, (error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
    }, accountId, destinationId);
  }
}

export const updateBillingEmailAction = (destinationId, address) => {
  return function(dispatch, getState) {
    const accountId = accountSelectors.getAccountId(getState());
    if (!accountId) return;
    
    AccountApi.updateBillingEmail((mailingList) => {
      dispatch({type: actionTypes.SET_BILLING_EMAILS, payload: { billingEmails: mailingList }});
      dispatch(coreActions.postSnackMessage('success', 'Email updated successfully'));
    }, (error, status, content) => {
      PortalApi.defaultErrorHandler(error, status, content);
    }, accountId, destinationId, address);
  }
}

